export const API_URL = 'roles'
export const ROUTE_NAME = 'roles'
